'use client';
import useWatcherPriceList from '#/data/useWatcherPriceList';
import formatUnits from '#/utils/formatUnits';
import parseUnits from '#/utils/parseUnits';
import { ethers } from 'ethers';
import { useMemo } from 'react';
import Skeleton from './Skeleton';

interface Props {
  symbol?: string;
}

export default function WatcherNetworkPrice({ symbol }: Props) {
  const { data: watcherPriceInfoData, isLoading } = useWatcherPriceList();
  const price = useMemo(() => {
    return watcherPriceInfoData?.data.data?.find(item => item.symbol === symbol)
      ?.price;
  }, [watcherPriceInfoData, symbol]);
  const priceAsBigNumber = useMemo(
    () => (price != null ? parseUnits(price, 8) : null),
    [price]
  );
  const displayDecimals = useMemo(() => {
    return priceAsBigNumber?.lt(parseUnits('1', 8)) ? 8 : 2;
  }, [priceAsBigNumber]);
  return (
    <Skeleton isLoading={isLoading} className="w-16">
      $
      {priceAsBigNumber
        ? ethers.utils.commify(
            formatUnits(priceAsBigNumber, 8, displayDecimals)
          )
        : null}
      <p className="inline-block text-sm text-gray-500 dark:text-gray-400">
        /{symbol}
      </p>
    </Skeleton>
  );
}
